/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CajaRouteImport } from './routes/caja'
import { Route as CatalogoRouteImport } from './routes/catalogo'
import { Route as CatalogoInternoRouteImport } from './routes/catalogo-interno'
import { Route as ChequesRouteImport } from './routes/cheques'
import { Route as ClientesRouteImport } from './routes/clientes'
import { Route as ComprasRouteImport } from './routes/compras'
import { Route as ConfiguracionRouteImport } from './routes/configuracion'
import { Route as CuentasCorrientesRouteImport } from './routes/cuentas-corrientes'
import { Route as GananciasRouteImport } from './routes/ganancias'
import { Route as InstalarRouteImport } from './routes/instalar'
import { Route as InventarioRouteImport } from './routes/inventario'
import { Route as ListasPreciosRouteImport } from './routes/listas-precios'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ProveedoresRouteImport } from './routes/proveedores'
import { Route as PuestaAPuntoRouteImport } from './routes/puesta-a-punto'
import { Route as ReparacionesRouteImport } from './routes/reparaciones'
import { Route as SociosRouteImport } from './routes/socios'
import { Route as TiendaRouteImport } from './routes/tienda'
import { Route as VentasRouteImport } from './routes/ventas'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CajaRoute = CajaRouteImport.update({
  id: '/caja',
  path: '/caja',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogoRoute = CatalogoRouteImport.update({
  id: '/catalogo',
  path: '/catalogo',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogoInternoRoute = CatalogoInternoRouteImport.update({
  id: '/catalogo-interno',
  path: '/catalogo-interno',
  getParentRoute: () => rootRouteImport,
} as any)
const ChequesRoute = ChequesRouteImport.update({
  id: '/cheques',
  path: '/cheques',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientesRoute = ClientesRouteImport.update({
  id: '/clientes',
  path: '/clientes',
  getParentRoute: () => rootRouteImport,
} as any)
const ComprasRoute = ComprasRouteImport.update({
  id: '/compras',
  path: '/compras',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfiguracionRoute = ConfiguracionRouteImport.update({
  id: '/configuracion',
  path: '/configuracion',
  getParentRoute: () => rootRouteImport,
} as any)
const CuentasCorrientesRoute = CuentasCorrientesRouteImport.update({
  id: '/cuentas-corrientes',
  path: '/cuentas-corrientes',
  getParentRoute: () => rootRouteImport,
} as any)
const GananciasRoute = GananciasRouteImport.update({
  id: '/ganancias',
  path: '/ganancias',
  getParentRoute: () => rootRouteImport,
} as any)
const InstalarRoute = InstalarRouteImport.update({
  id: '/instalar',
  path: '/instalar',
  getParentRoute: () => rootRouteImport,
} as any)
const InventarioRoute = InventarioRouteImport.update({
  id: '/inventario',
  path: '/inventario',
  getParentRoute: () => rootRouteImport,
} as any)
const ListasPreciosRoute = ListasPreciosRouteImport.update({
  id: '/listas-precios',
  path: '/listas-precios',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProveedoresRoute = ProveedoresRouteImport.update({
  id: '/proveedores',
  path: '/proveedores',
  getParentRoute: () => rootRouteImport,
} as any)
const PuestaAPuntoRoute = PuestaAPuntoRouteImport.update({
  id: '/puesta-a-punto',
  path: '/puesta-a-punto',
  getParentRoute: () => rootRouteImport,
} as any)
const ReparacionesRoute = ReparacionesRouteImport.update({
  id: '/reparaciones',
  path: '/reparaciones',
  getParentRoute: () => rootRouteImport,
} as any)
const SociosRoute = SociosRouteImport.update({
  id: '/socios',
  path: '/socios',
  getParentRoute: () => rootRouteImport,
} as any)
const TiendaRoute = TiendaRouteImport.update({
  id: '/tienda',
  path: '/tienda',
  getParentRoute: () => rootRouteImport,
} as any)
const VentasRoute = VentasRouteImport.update({
  id: '/ventas',
  path: '/ventas',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/caja': typeof CajaRoute
  '/catalogo': typeof CatalogoRoute
  '/catalogo-interno': typeof CatalogoInternoRoute
  '/cheques': typeof ChequesRoute
  '/clientes': typeof ClientesRoute
  '/compras': typeof ComprasRoute
  '/configuracion': typeof ConfiguracionRoute
  '/cuentas-corrientes': typeof CuentasCorrientesRoute
  '/ganancias': typeof GananciasRoute
  '/instalar': typeof InstalarRoute
  '/inventario': typeof InventarioRoute
  '/listas-precios': typeof ListasPreciosRoute
  '/login': typeof LoginRoute
  '/proveedores': typeof ProveedoresRoute
  '/puesta-a-punto': typeof PuestaAPuntoRoute
  '/reparaciones': typeof ReparacionesRoute
  '/socios': typeof SociosRoute
  '/tienda': typeof TiendaRoute
  '/ventas': typeof VentasRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/caja': typeof CajaRoute
  '/catalogo': typeof CatalogoRoute
  '/catalogo-interno': typeof CatalogoInternoRoute
  '/cheques': typeof ChequesRoute
  '/clientes': typeof ClientesRoute
  '/compras': typeof ComprasRoute
  '/configuracion': typeof ConfiguracionRoute
  '/cuentas-corrientes': typeof CuentasCorrientesRoute
  '/ganancias': typeof GananciasRoute
  '/instalar': typeof InstalarRoute
  '/inventario': typeof InventarioRoute
  '/listas-precios': typeof ListasPreciosRoute
  '/login': typeof LoginRoute
  '/proveedores': typeof ProveedoresRoute
  '/puesta-a-punto': typeof PuestaAPuntoRoute
  '/reparaciones': typeof ReparacionesRoute
  '/socios': typeof SociosRoute
  '/tienda': typeof TiendaRoute
  '/ventas': typeof VentasRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/caja': typeof CajaRoute
  '/catalogo': typeof CatalogoRoute
  '/catalogo-interno': typeof CatalogoInternoRoute
  '/cheques': typeof ChequesRoute
  '/clientes': typeof ClientesRoute
  '/compras': typeof ComprasRoute
  '/configuracion': typeof ConfiguracionRoute
  '/cuentas-corrientes': typeof CuentasCorrientesRoute
  '/ganancias': typeof GananciasRoute
  '/instalar': typeof InstalarRoute
  '/inventario': typeof InventarioRoute
  '/listas-precios': typeof ListasPreciosRoute
  '/login': typeof LoginRoute
  '/proveedores': typeof ProveedoresRoute
  '/puesta-a-punto': typeof PuestaAPuntoRoute
  '/reparaciones': typeof ReparacionesRoute
  '/socios': typeof SociosRoute
  '/tienda': typeof TiendaRoute
  '/ventas': typeof VentasRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/caja'
    | '/catalogo'
    | '/catalogo-interno'
    | '/cheques'
    | '/clientes'
    | '/compras'
    | '/configuracion'
    | '/cuentas-corrientes'
    | '/ganancias'
    | '/instalar'
    | '/inventario'
    | '/listas-precios'
    | '/login'
    | '/proveedores'
    | '/puesta-a-punto'
    | '/reparaciones'
    | '/socios'
    | '/tienda'
    | '/ventas'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/caja'
    | '/catalogo'
    | '/catalogo-interno'
    | '/cheques'
    | '/clientes'
    | '/compras'
    | '/configuracion'
    | '/cuentas-corrientes'
    | '/ganancias'
    | '/instalar'
    | '/inventario'
    | '/listas-precios'
    | '/login'
    | '/proveedores'
    | '/puesta-a-punto'
    | '/reparaciones'
    | '/socios'
    | '/tienda'
    | '/ventas'
  id:
    | '__root__'
    | '/'
    | '/caja'
    | '/catalogo'
    | '/catalogo-interno'
    | '/cheques'
    | '/clientes'
    | '/compras'
    | '/configuracion'
    | '/cuentas-corrientes'
    | '/ganancias'
    | '/instalar'
    | '/inventario'
    | '/listas-precios'
    | '/login'
    | '/proveedores'
    | '/puesta-a-punto'
    | '/reparaciones'
    | '/socios'
    | '/tienda'
    | '/ventas'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CajaRoute: typeof CajaRoute
  CatalogoRoute: typeof CatalogoRoute
  CatalogoInternoRoute: typeof CatalogoInternoRoute
  ChequesRoute: typeof ChequesRoute
  ClientesRoute: typeof ClientesRoute
  ComprasRoute: typeof ComprasRoute
  ConfiguracionRoute: typeof ConfiguracionRoute
  CuentasCorrientesRoute: typeof CuentasCorrientesRoute
  GananciasRoute: typeof GananciasRoute
  InstalarRoute: typeof InstalarRoute
  InventarioRoute: typeof InventarioRoute
  ListasPreciosRoute: typeof ListasPreciosRoute
  LoginRoute: typeof LoginRoute
  ProveedoresRoute: typeof ProveedoresRoute
  PuestaAPuntoRoute: typeof PuestaAPuntoRoute
  ReparacionesRoute: typeof ReparacionesRoute
  SociosRoute: typeof SociosRoute
  TiendaRoute: typeof TiendaRoute
  VentasRoute: typeof VentasRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/caja': {
      id: '/caja'
      path: '/caja'
      fullPath: '/caja'
      preLoaderRoute: typeof CajaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogo': {
      id: '/catalogo'
      path: '/catalogo'
      fullPath: '/catalogo'
      preLoaderRoute: typeof CatalogoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogo-interno': {
      id: '/catalogo-interno'
      path: '/catalogo-interno'
      fullPath: '/catalogo-interno'
      preLoaderRoute: typeof CatalogoInternoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cheques': {
      id: '/cheques'
      path: '/cheques'
      fullPath: '/cheques'
      preLoaderRoute: typeof ChequesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clientes': {
      id: '/clientes'
      path: '/clientes'
      fullPath: '/clientes'
      preLoaderRoute: typeof ClientesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compras': {
      id: '/compras'
      path: '/compras'
      fullPath: '/compras'
      preLoaderRoute: typeof ComprasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuracion': {
      id: '/configuracion'
      path: '/configuracion'
      fullPath: '/configuracion'
      preLoaderRoute: typeof ConfiguracionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cuentas-corrientes': {
      id: '/cuentas-corrientes'
      path: '/cuentas-corrientes'
      fullPath: '/cuentas-corrientes'
      preLoaderRoute: typeof CuentasCorrientesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ganancias': {
      id: '/ganancias'
      path: '/ganancias'
      fullPath: '/ganancias'
      preLoaderRoute: typeof GananciasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instalar': {
      id: '/instalar'
      path: '/instalar'
      fullPath: '/instalar'
      preLoaderRoute: typeof InstalarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventario': {
      id: '/inventario'
      path: '/inventario'
      fullPath: '/inventario'
      preLoaderRoute: typeof InventarioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/listas-precios': {
      id: '/listas-precios'
      path: '/listas-precios'
      fullPath: '/listas-precios'
      preLoaderRoute: typeof ListasPreciosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proveedores': {
      id: '/proveedores'
      path: '/proveedores'
      fullPath: '/proveedores'
      preLoaderRoute: typeof ProveedoresRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/puesta-a-punto': {
      id: '/puesta-a-punto'
      path: '/puesta-a-punto'
      fullPath: '/puesta-a-punto'
      preLoaderRoute: typeof PuestaAPuntoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reparaciones': {
      id: '/reparaciones'
      path: '/reparaciones'
      fullPath: '/reparaciones'
      preLoaderRoute: typeof ReparacionesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/socios': {
      id: '/socios'
      path: '/socios'
      fullPath: '/socios'
      preLoaderRoute: typeof SociosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tienda': {
      id: '/tienda'
      path: '/tienda'
      fullPath: '/tienda'
      preLoaderRoute: typeof TiendaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ventas': {
      id: '/ventas'
      path: '/ventas'
      fullPath: '/ventas'
      preLoaderRoute: typeof VentasRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CajaRoute: CajaRoute,
  CatalogoRoute: CatalogoRoute,
  CatalogoInternoRoute: CatalogoInternoRoute,
  ChequesRoute: ChequesRoute,
  ClientesRoute: ClientesRoute,
  ComprasRoute: ComprasRoute,
  ConfiguracionRoute: ConfiguracionRoute,
  CuentasCorrientesRoute: CuentasCorrientesRoute,
  GananciasRoute: GananciasRoute,
  InstalarRoute: InstalarRoute,
  InventarioRoute: InventarioRoute,
  ListasPreciosRoute: ListasPreciosRoute,
  LoginRoute: LoginRoute,
  ProveedoresRoute: ProveedoresRoute,
  PuestaAPuntoRoute: PuestaAPuntoRoute,
  ReparacionesRoute: ReparacionesRoute,
  SociosRoute: SociosRoute,
  TiendaRoute: TiendaRoute,
  VentasRoute: VentasRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
